<template>
  <v-container fluid class="fill-height">
    <div class="mx-auto pa-2 text-center register fill-width fill-height">
      <v-card elevation="0" color="gray1" class="mb-3">
        <v-card-title class="font-semiBold-20 text-center d-block py-1">
          {{ $t("panel.adminManagement.invitedAdminPage.title") }}
        </v-card-title>
        <v-card-text class="font-regular-16 text-center">
          {{ $t("panel.adminManagement.invitedAdminPage.description") }}
        </v-card-text>
      </v-card>
      <v-form
        @submit.prevent="onSubmit"
        ref="register"
        class="d-flex flex-column justify-between align-center invite-admin-form pt-3"
      >
        <v-col
          cols="12"
          lg="9"
          class="d-flex justify-space-around align-center align-content-start flex-wrap invite-admin-form_col"
        >
          <v-text-field
            type="text"
            :label="
              $t('panel.adminManagement.invitedAdminPage.userInfo.firstName')
            "
            :rules="rules.firstNameRules"
            autofocus
            v-model="userInfo.firstName"
            class="theme-custom-input no-border mx-1"
            outlined
          />

          <v-text-field
            type="text"
            :label="
              $t('panel.adminManagement.invitedAdminPage.userInfo.lastName')
            "
            :rules="rules.lastNameRules"
            v-model="userInfo.lastName"
            class="theme-custom-input no-border mx-1"
            outlined
          />

          <v-text-field
            type="number"
            :label="
              $t('panel.adminManagement.invitedAdminPage.userInfo.mobile')
            "
            v-model="userInfo.mobile"
            class="theme-custom-input no-border mx-1"
            outlined
          />

          <v-text-field
            type="email"
            :label="$t('panel.adminManagement.invitedAdminPage.userInfo.email')"
            :rules="rules.emailRules"
            v-model="userInfo.email"
            class="theme-custom-input no-border mx-1"
            outlined
          />

          <v-text-field
            :type="userInfo.showPassword ? 'text' : 'password'"
            :label="
              $t('panel.adminManagement.invitedAdminPage.userInfo.password')
            "
            :rules="rules.passwordRules"
            v-model="userInfo.password"
            class="theme-custom-input no-border mx-1"
            outlined
          >
            <template v-slot:append>
              <div
                @click="userInfo.showPassword = !userInfo.showPassword"
                class="show-password-append"
              >
                <v-icon
                  size="24"
                  v-if="userInfo.showPassword"
                  class="cursor-pointer"
                  >$eyeShow</v-icon
                >
                <v-icon size="24" class="cursor-pointer" v-else
                  >$eyeHidden</v-icon
                >
              </div>
            </template>
          </v-text-field>
          <div class="order-0 order-sm-1 password-regulation">
            <PasswordRegulation
              @conditionsResult="conditionsResult"
              :submission="submission"
              :password="userInfo.password"
            />
          </div>
          <div class="order-sm-1 password-regulation d-none d-sm-block"></div>

          <v-text-field
            :type="userInfo.showPasswordRepetition ? 'text' : 'password'"
            :label="
              $t(
                'panel.adminManagement.invitedAdminPage.userInfo.passwordRepetition'
              )
            "
            :rules="rules.passwordRepetitionRules"
            v-model="userInfo.passwordRepetition"
            validate-on-blur
            class="theme-custom-input no-border mx-1"
            outlined
          >
            <template v-slot:append>
              <div
                @click="
                  userInfo.showPasswordRepetition = !userInfo.showPasswordRepetition
                "
                class="show-password-append"
              >
                <v-icon
                  size="24"
                  v-if="userInfo.showPasswordRepetition"
                  class="cursor-pointer"
                  >$eyeShow</v-icon
                >
                <v-icon size="24" class="cursor-pointer" v-else
                  >$eyeHidden</v-icon
                >
              </div>
            </template>
          </v-text-field>
        </v-col>
        <v-card-actions class="pa-0 submit-btn mt-auto">
          <v-btn
            color="primary"
            depressed
            :loading="loading"
            block
            class="py-7 mb-2"
            type="submit"
            width="300px"
            max-width="100%"
            >{{ $t("panel.adminManagement.invitedAdminPage.nextBtn") }}</v-btn
          >
        </v-card-actions>
      </v-form>
    </div>
  </v-container>
</template>
<script>
import { authService } from "@/services";
import PasswordRegulation from "@/components/Auth/PasswordRegulation";

export default {
  name: "admin-management-inviteAdmin",
  components: { PasswordRegulation },
  props: [],
  data() {
    return {
      result: false,
      submission: false,
      loading: false,
      userInfo: {
        firstName: "",
        lastName: "",
        mobile: "",
        email: "",
        password: "",
        passwordRepetition: "",
        showPasswordRepetition: false,
        showPassword: false
      },

      rules: {
        firstNameRules: [
          v =>
            !!v ||
            this.$t(
              "panel.adminManagement.invitedAdminPage.rules.firstNameNotEmpty"
            )
        ],
        lastNameRules: [
          v =>
            !!v ||
            this.$t(
              "panel.adminManagement.invitedAdminPage.rules.lastNameNotEmpty"
            )
        ],
        mobileRules: [
          v =>
            !!v ||
            this.$t(
              "panel.adminManagement.invitedAdminPage.rules.mobileNotEmpty"
            )
        ],
        emailRules: [
          v =>
            !!v ||
            this.$t(
              "panel.adminManagement.invitedAdminPage.rules.emailNotEmpty"
            ),
          v =>
            /.+@.+\..+/.test(v) ||
            this.$t(
              "panel.adminManagement.invitedAdminPage.rules.emailIsInvalid"
            )
        ],
        passwordRules: [
          val =>
            !!val ||
            this.$t(
              "panel.adminManagement.invitedAdminPage.rules.passwordNotEmpty"
            )
        ],
        passwordRepetitionRules: [
          val =>
            !!val ||
            this.$t(
              "panel.adminManagement.invitedAdminPage.rules.passwordRepetitionNotEmpty"
            ),
          val =>
            val === this.userInfo.password ||
            this.$t("panel.adminManagement.invitedAdminPage.rules.noMatch")
        ]
      }
    };
  },
  computed: {},
  methods: {
    conditionsResult(val) {
      this.result = val;
    },
    onSubmit() {
      if (!this.$refs.register.validate() && !this.result) {
        this.submission = true;
        return;
      }
      this.loading = true;
      authService
        .register({
          firstName: this.userInfo.firstName,
          lastName: this.userInfo.lastName,
          mobileNumber: this.userInfo.mobile,
          email: this.userInfo.email,
          password: this.userInfo.password,
          confirmPassword: this.userInfo.passwordRepetition,
          roles: []
        })
        .then(response => {
          const userId = response.data.data.id || 0;
          this.$router.replace({ name: "editUserRoles", params: { userId } });
          // this.$toast.success(
          //   this.$t("panel.adminManagement.invitedAdminPage.rules.successMsgToast")
          // );
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
<style lang="scss">
@import "InviteAdmin";
</style>
